import { Injectable } from "@angular/core";

export interface AppToast {
  id: number;
  summary: string;
  detail: string;
}

/** Shows a short message at the bottom-left of the page. */
@Injectable({ providedIn: "root" })
export class ToastService {
  private nextId = 0;

  add(message: { summary: string; detail: string; life?: number }): void {
    if (typeof document === "undefined") {
      return;
    }

    const id = ++this.nextId;
    const toast = document.createElement("div");
    toast.id = `dua-toast-${id}`;
    toast.setAttribute("role", "status");
    toast.style.cssText = [
      "min-width:280px",
      "max-width:400px",
      "padding:12px 16px",
      "background:#ffffff",
      "color:#495057",
      "border:1px solid #1ea97c",
      "border-left-width:6px",
      "border-radius:6px",
      "box-shadow:0 2px 12px rgba(0,0,0,0.25)",
      "font-family:Helvetica,Arial,sans-serif",
      "font-size:16px",
      "line-height:1.35",
    ].join(";");

    const summary = document.createElement("strong");
    summary.textContent = message.summary;
    summary.style.cssText = "display:block;color:#1ea97c;font-weight:700;";

    const detail = document.createElement("p");
    detail.textContent = message.detail;
    detail.style.cssText = "margin:4px 0 0;color:#495057;";

    toast.append(summary, detail);
    this.stack().appendChild(toast);

    window.setTimeout(() => toast.remove(), message.life ?? 3000);
  }

  private stack(): HTMLElement {
    const existing = document.getElementById("dua-toast-stack");
    if (existing) {
      return existing;
    }

    const stack = document.createElement("div");
    stack.id = "dua-toast-stack";
    stack.style.cssText = [
      "position:fixed",
      "left:20px",
      "bottom:20px",
      "z-index:10000",
      "display:flex",
      "flex-direction:column",
      "gap:8px",
    ].join(";");
    document.body.appendChild(stack);
    return stack;
  }
}
